namespace advisorop.components.servicer {

    class WorkflowDiagramController {

        lovs: Array<domains.ILOV> = [];

        biDictionaryElements: domains.ILOV[] = [];
        biCompareOperators: domains.ILOV[] = [];
        workflowStepPermissions: domains.ILOV[] = [];
        aoAutomatedTasks: domains.ILOV[] = [];

        selBITriggerElement: domains.ILOV;
        selBITriggerOperator: domains.ILOV;

        selBIDictionaryElement: domains.ILOV;
        selBICompareOperatorPositive: domains.ILOV;
        selAOAutomatedTask: domains.ILOV;
        selWorkflowStepPermission: domains.ILOV;

        wfdiagram: DevExpress.ui.dxDiagramOptions;

        updatingWorkflowLadda: boolean = false;

        model: domains.IWorkflowMaster;

        workflowNodesArrayDataSource: DevExpress.data.ArrayStore;
        workflowEdgesArrayDataSource: DevExpress.data.ArrayStore;
        workflowNodesDataSource: DevExpress.data.DataSource;
        workflowEdgesDataSource: DevExpress.data.DataSource;

        showDiagram = true;
        showEditFields = false;
        selElementIsDirty = false;
        selDiagramIsDirty = false;
        selItemItemType: string;
        selItemType: string;
        selKey: string;
        selNode: domains.IWorkflowShape;
        selEdge: domains.IWorkflowConnector;
        onSaveWorkflow: any;

        initialWorkflowNodes: domains.IWorkflowShape[];
        initialWorkflowEdges: domains.IWorkflowConnector[];

        nodeMap: Map<string, domains.IWorkflowShape>;
        edgeMap: Map<string, domains.IWorkflowConnector>;

        decisionConstant = constants.WORKFLOW_DECISION;
        processConstant = constants.WORKFLOW_PROCESS;
        //terminatorConstant = constants.WORKFLOW_TERMINATOR;
        //connectorConstant = constants.WORKFLOW_CONNECTOR;

        public theDiagram: DevExpress.ui.dxDiagram;

        static $inject = ["generalService", "identityService", "servicerService", "advisoryFirmApi", "workflowApi"];
        constructor(private generalService: services.GeneralService,
            private identityService: services.IdentityService,
            private servicerService: services.ServicerService,
            private advisoryFirmApi: services.AdvisoryFirmApi,
            private workflowApi: services.WorkflowApi) {

            this.selNode = new domains.IWorkflowShape();
            this.selEdge = new domains.IWorkflowConnector();

            this.nodeMap = new Map<string, domains.IWorkflowShape>();
            this.edgeMap = new Map<string, domains.IWorkflowConnector>();

        }
        initModelComponents(): void {
            this.initNodemap();
            this.initEdgemap();

            this.wfdiagram = <DevExpress.ui.dxDiagramOptions>({
                width: "100%",
                height: "100%",
                nodes: {
                    dataSource: new DevExpress.data.DataSource({
                        key: "this",
                        store: new DevExpress.data.ArrayStore({
                            key: "id",
                            data: this.getWorkflowNodesArrayData(),
                        })
                    })
                },
                edges: {
                    dataSource: new DevExpress.data.DataSource({
                        key: "this",
                        store: new DevExpress.data.ArrayStore({
                            key: "id",
                            data: this.getWorkflowEdgesArrayData(),
                        })
                    }),
                    textExpr: "text",
                },
                focusStateEnabled: false,
                fullScreen: false,
                //rtlEnabled: false,
                simpleView: true,
                propertiesPanel:
                {
                    visibility: "disabled"
                },
                contextMenu:
                {
                    enabled: true,
                    commands: ["copy", "cut", "paste", "delete", "insertShapeImage"]
                },
                autoZoomMode: "fitWidth",
                pageColor: "#82CAFA",
                toolbox: {
                    showSearch: false,
                    groups: [
                        {
                            category: "workflow objects",
                            displayMode: "icons",
                            expanded: true,
                            shapes: [constants.WORKFLOW_TERMINATOR, constants.WORKFLOW_PROCESS, constants.WORKFLOW_DECISION],
                            title: "Workflow Objects"
                        },
                    ]
                },
                viewToolbar:
                {
                    visible: false
                },
                onInitialized: (e) => {
                    this.theDiagram = e.component;
                },
                onItemClick: (e: any) => {
                    //console.log("item has been clicked :", e);

                    if (this.selDiagramIsDirty) {
                        if (window.confirm("Save previous shape changes?")) {
                            this.saveSelData();
                        }
                    }

                    const itemKey = e.item.key ?? e.item.dataItem.id;

                    this.selItemType = e.item.type;
                    //console.log("ITEM SELECTED", e.item);

                    // Sync our nodemap - add any new shapes
                    if (e.item.type !== constants.WORKFLOW_TERMINATOR) {
                        if (e.item.itemType === "shape") {
                            this.selItemItemType = "Shape";
                            this.selItemItemType = "Shape";
                            this.bindNodeToForm(itemKey);
                            this.selElementIsDirty = false;
                            this.selDiagramIsDirty = false;
                            this.showEditFields = true;

                        } else if (e.item.itemType === constants.WORKFLOW_CONNECTOR) {
                            this.selItemItemType = "Connector";
                            if (this.bindEdgeToForm(itemKey)) {
                                this.selElementIsDirty = false;
                                this.selDiagramIsDirty = false;
                                this.showEditFields = true;
                            } else {
                                this.showEditFields = false;
                            }

                            // old test code... ignore
                            //var dStore = theDiagram.getNodeDataSource().store();
                            //let ind = theDiagram.getNodeDataSource().items().findIndex(node => node.id == e.item.key);
                            //var itms = theDiagram.getNodeDataSource().items();
                            //itms[ind].name = "BBBDJAEE";
                            //theDiagram.getNodeDataSource().reload();
                            //theDiagram.repaint();

                        } else {
                            this.showEditFields = false;
                        }
                    } else {
                        this.showEditFields = false;
                    }
                },
                onRequestLayoutUpdate: (e: any) => {
                    //console.log("IN UPDATE CALLBACK!!!!!", e);
                    e.changes.forEach(change => {
                        if (change.type === "insert" || change.type === "update") {
                            if (change.data.hasOwnProperty('type')) {
                                // shape
                                //console.log("ADDING/UPDATING SHAPESHAPE");
                                this.bindNodeToForm(change.key);
                            } else if (change.data.hasOwnProperty('from')) {
                                // connector
                                //console.log("ADDING/UPDATING EDGE");
                                this.bindEdgeToForm(change.key);
                            }
                        } else if (change.type === "remove") {
                            if (this.nodeMap.has(change.key)) {
                                //console.log("DELETING SHAPE");
                                this.nodeMap.delete(change.key);
                            } else if (this.edgeMap.has(change.key)) {
                                //console.log("DELETING EDGE");
                                this.edgeMap.delete(change.key);
                            }
                        }
                    });
                },
                //onSelectionChanged: (e: any) => {
                //    console.log("IN ON SELECTION CHANGED!!!!!", e);
                //},
                //onOptionChanged: (e: any) => {
                //    console.log("IN ON OPTION CHANGED!!!!!", e);
                //},
                hoverStateEnabled: true,
                //onRequestEditOperation: (e: any) => {
                //    console.log("IN ON REQUEST EDIT OPERATION!!!!!", e);
                //},
                customShapes: [
                    {
                        baseType: "process",
                        type: constants.WORKFLOW_PROCESS,
                        toolboxTemplate: "toolboxTemplate"
                    },
                    {
                        baseType: "decision",
                        type: constants.WORKFLOW_DECISION,
                        toolboxTemplate: "toolboxTemplate"
                    },
                ],
                customShapeTemplate: "nodeShapeTemplate",
            });
        }

        initNodemap(): void {
            this.nodeMap.clear();
            if (this.model != undefined) {
                // initialize the nodemap with supplemntal fields - this is our internal data structure where we manage the supplemental node data
                this.model.diagram.shapes.forEach(n => {
                    var node = new domains.IWorkflowShape();
                    node.id = n.id;
                    node.claimAllowedAllTimes = n.claimAllowedAllTimes;
                    node.autoComplete = n.autoComplete;
                    node.biDictionaryElement = n.biDictionaryElement;
                    node.biCompareOperatorPositive = n.biCompareOperatorPositive;
                    node.aoAutomatedTask = n.aoAutomatedTask;
                    node.stepPermissionedRole = n.stepPermissionedRole;
                    this.nodeMap.set(node.id, node);
                });
            }
        }

        initEdgemap(): void {
            this.edgeMap.clear();
            if(this.model != undefined) {
                // initialize the edgemap eith supplemntal fields - this is our internal data structure where we manage the supplemental edge data
                this.model.diagram.connectors.forEach(n => {
                    var edge = new domains.IWorkflowConnector();
                    edge.id = n.id;
                    edge.positivityIndicator = n.positivityIndicator;

                    this.edgeMap.set(edge.id, edge);
                });
            }
        }

        infoToolTipHtml(item: any): string {
            //console.log("TOOLTIP HTML", item);

            var ret = "";

            //var theDiagram = $("#dxWorkflowDiagram").dxDiagram("instance");
            const nodeData = this.theDiagram.getNodeDataSource().items();
            const ind = nodeData.findIndex(node => node.id === item.key);
            if (ind >= 0) {
                const text = (nodeData[ind].hasOwnProperty('text')) ? nodeData[ind].text : "";

                ret = "<p><h5>Properties:</h5></p>";
                ret += "<p style=text-align:\"left\"><strong>Name:</strong> " + text + "<br /><br />";

                if (this.nodeMap.has(item.key)) {
                    const itemm = this.nodeMap.get(item.key);
                    ret += "<strong>Description:</strong> " + itemm.description + "<br /><br />";
                    ret += "<strong>Allow claim out of order:</strong> " + (itemm.claimAllowedAllTimes == true ? "Yes" : "No") + "<br /><br />";
                    ret += "<strong>Automated Step:</strong> " + (itemm.autoComplete == true ? "Yes" : "No") + "</p>";
                    ret += "<strong>Related Field:</strong> " + (itemm.biDictionaryElement ? this.biDictionaryElements.find(w => w.value == itemm.biDictionaryElement).name : "") + "</p>";
                    ret += "<strong>Comparison Operator:</strong> " + (itemm.biCompareOperatorPositive ? this.biCompareOperators.find(w => w.value == itemm.biCompareOperatorPositive).name : "") + "</p>";
                    ret += "<strong>AO Automated Task:</strong> " + (itemm.aoAutomatedTask ? this.aoAutomatedTasks.find(w => w.value == itemm.aoAutomatedTask).name : "") + "</p>";
                    ret += "<strong>Permissioned Role:</strong> " + (itemm.stepPermissionedRole ? this.workflowStepPermissions.find(w => w.value == itemm.stepPermissionedRole).name : "") + "</p>";
                } else {
                    ret += "<strong>Description:</strong> undefined<br /><br />";
                    ret += "<strong>Allow claim out of order:</strong> No<br /><br />";
                    ret += "<strong>Automated Step:</strong> No</p>";
                    ret += "<strong>Relataed Field:</strong> None</p>";
                    ret += "<strong>Comparison Operator:</strong> None</p>";
                    ret += "<strong>AO Automated Task:</strong> None</p>";
                    ret += "<strong>Permissioned Role:</strong> None</p>";
                }
            }

            //console.log("RETURNING TOOLTIP HTML:", ret)
            return ret;
        }

        bindNodeToForm(key: string) {
            //console.log("BINDING NODE TO FORM FOR KEY:", key);

            //var theDiagram = $("#dxWorkflowDiagram").dxDiagram("instance");
            const nodeData = this.theDiagram.getNodeDataSource().items();

            this.selKey = key;
            this.selNode.id = key;
            const ind = nodeData.findIndex(node => node.id === key);
            this.selNode.text = nodeData[ind].hasOwnProperty('text') ? nodeData[ind].text : "";

            //console.log("IND----:", ind);
            //console.log("SET NODE TEXT TO:", this.selNode.text);

            if (this.nodeMap.has(key)) {
                const node = this.nodeMap.get(key);
                this.selNode.description = node.description;
                this.selNode.claimAllowedAllTimes = node.claimAllowedAllTimes;
                this.selNode.autoComplete = node.autoComplete;
                this.selNode.biDictionaryElement = node.biDictionaryElement;
                this.selNode.biCompareOperatorPositive = node.biCompareOperatorPositive;
                this.selNode.aoAutomatedTask = node.aoAutomatedTask;
                this.selNode.stepPermissionedRole = node.stepPermissionedRole;
                this.selBIDictionaryElement = this.biDictionaryElements.find(w => w.value == this.selNode.biDictionaryElement);
                this.selBICompareOperatorPositive = this.biCompareOperators.find(w => w.value == this.selNode.biCompareOperatorPositive);
                this.selAOAutomatedTask = this.aoAutomatedTasks.find(w => w.value == this.selNode.aoAutomatedTask);
                this.selWorkflowStepPermission = this.workflowStepPermissions.find(w => w.value == this.selNode.stepPermissionedRole);
            } else {
                this.selNode.description = undefined;
                this.selNode.claimAllowedAllTimes = false;
                this.selNode.autoComplete = false;
                this.selNode.biDictionaryElement = undefined;
                this.selNode.biCompareOperatorPositive = undefined;
                this.selNode.aoAutomatedTask = undefined;
                this.selNode.stepPermissionedRole = undefined;
                this.selBIDictionaryElement = undefined
                this.selBICompareOperatorPositive = undefined;
                this.selAOAutomatedTask = undefined;
                this.selWorkflowStepPermission = undefined;
            }
        }

        bindEdgeToForm(key: string): boolean {
            //console.log("BINDING EDGE TO FORM FOR KEY:", key);

            //var theDiagram = $("#dxWorkflowDiagram").dxDiagram("instance");
            const edgeData = this.theDiagram.getEdgeDataSource().items();
            const nodeData = this.theDiagram.getNodeDataSource().items();
            //console.log("EDGE ITMS:", edgeData);

            const ind = edgeData.findIndex(edge => edge.id === key);
            //console.log("IND----:", ind);
            const fromNode = nodeData.findIndex(node => node.id === edgeData[ind].from);

            // For edges, we only bind to the form when the edge comes from a decision node.
            if (fromNode >= 0 && nodeData[fromNode].type === constants.WORKFLOW_DECISION) {
                this.selKey = key;
                this.selEdge.id = key;

                this.selEdge.text = edgeData[ind].hasOwnProperty('text') ? edgeData[ind].text : "";
                //console.log("SET EDGE TEXT TO:", this.selEdge.text);

                if (this.edgeMap.has(key)) {
                    const edge = this.edgeMap.get(key);
                    this.selEdge.description = edge.description;
                    this.selEdge.positivityIndicator = edge.positivityIndicator;
                } else {
                    this.selEdge.description = undefined;
                    this.selEdge.positivityIndicator = undefined;
                }
                return true;
            } else {
                return false;
            }
        }

        setBIDictionaryTriggerElement() {
            this.model.biDictionaryTriggerElement = this.selBITriggerElement?.value;
            this.setElementDirty(true);
        }

        setBITriggerOperator() {
            this.model.biTriggerOperator = this.selBITriggerOperator?.value;
            this.setElementDirty(true);
        }

        setWorkflowStepPermission() {
            this.selNode.stepPermissionedRole = this.selWorkflowStepPermission?.value;
            this.setElementDirty();
        }

        setBIDictionaryElement() {
            this.selNode.biDictionaryElement = this.selBIDictionaryElement?.value;
            this.setElementDirty();
        }

        setBICompareOperatorPositive() {
            this.selNode.biCompareOperatorPositive = this.selBICompareOperatorPositive?.value;
            this.setElementDirty();
        }

        setAOAutomatedTask() {
            this.selNode.aoAutomatedTask = this.selAOAutomatedTask?.value;
            this.setElementDirty();
        }


        setElementDirty(notADiagramChange: boolean = true) {
            //console.log("Setting the selected element to dirty");
            this.selElementIsDirty = true;
            if (notADiagramChange)
                this.selDiagramIsDirty = true;
        }

        resetSelDataInForm(): void {
            if (this.selItemItemType === "Shape") {
                this.bindNodeToForm(this.selKey);
                this.selElementIsDirty = false;
                this.selDiagramIsDirty = false;
            }
            else if (this.selItemItemType === "Connector") {
                this.bindEdgeToForm(this.selKey);
                this.selElementIsDirty = false;
                this.selDiagramIsDirty = false;
            }
        }

        cancelSelDataUpdate(): void {
            this.showEditFields = false;
            this.selElementIsDirty = false;
            this.selDiagramIsDirty = false;
        }

        saveSelData(): void {
            if (this.selItemItemType === "Shape") {
                if (this.nodeMap.has(this.selKey)) {
                    this.nodeMap.delete(this.selKey);
                }
                this.nodeMap.set(this.selKey, angular.copy(this.selNode));
            }
            else if (this.selItemItemType === "Connector") {
                if (this.edgeMap.has(this.selKey)) {
                    this.edgeMap.delete(this.selKey);
                }
                this.edgeMap.set(this.selKey, angular.copy(this.selEdge));
            }
            this.selElementIsDirty = false;
            this.selDiagramIsDirty = false;
        }

        getWorkflowNodesArrayData() {
            return this.model.diagram.shapes;
        }

        getWorkflowEdgesArrayData() {
            return this.model.diagram.connectors;
        }

        okToSave(): boolean {
            return (this.model.name && this.model.description && (this.model.linkToInvestorOrHousehold || this.model.linkToAccount));
        }

        saveNewWorkflow(): void {
            this.buildWorkflowModel();
            //console.log("THE MODEL TO SAVE IS", this.model);

            this.workflowApi.createWorkflow(this.model).
                then(data => {
                    //console.log("Workflow successfully created. Response Data:", data);
                    toastr.success("Workflow successfully created.");
                    this.model = data.data;
                    this.selBITriggerElement = this.biDictionaryElements.find(w => w.value == this.model.biDictionaryTriggerElement);
                    this.selBITriggerOperator = this.biCompareOperators.find(w => w.value == this.model.biTriggerOperator);
                    //this.redrawCurrentWorkflow()
                    var modelId = this.model.id;
                    this.onSaveWorkflow({ modelId });
                }).
                catch(err => {
                    toastr.error("Unable to create workflow:", err);
                });
        };

        updateWorkflow(): void {
            this.buildWorkflowModel();
            //console.log("THE MODEL TO UPDATE IS", this.model);

            this.workflowApi.updateWorkflow(this.model).
                then(data => {
                    //console.log("Workflow successfully updated. Response Data:", data);
                    toastr.success("Workflow successfully updated.");
                    this.model = data.data;
                    this.selBITriggerElement = this.biDictionaryElements.find(w => w.value == this.model.biDictionaryTriggerElement);
                    this.selBITriggerOperator = this.biCompareOperators.find(w => w.value == this.model.biTriggerOperator);
                    //this.redrawCurrentWorkflow();
                    var modelId = this.model.id;
                    this.onSaveWorkflow({ modelId });
                }).
                catch(err => {
                    toastr.error("Unable to update workflow:", err);
                });
        };

        redrawCurrentWorkflow(): void {
            this.buildWorkflowModel();
            //var theDiagram = $("#dxWorkflowDiagram").dxDiagram("instance");
            this.theDiagram.getNodeDataSource().reload();
            this.theDiagram.getEdgeDataSource().reload();
            //console.log("REDRAW WORKFLOW, CURRENT WORKFLOW IS:", this.model);
        }

        buildWorkflowModel(): void {
            this.model.advisoryFirmId = 1;
            //var theDiagram = $("#dxWorkflowDiagram").dxDiagram("instance");
            this.model.biDictionaryTriggerElement = this.selBITriggerElement?.value;
            this.model.biTriggerOperator = this.selBITriggerOperator?.value;

            this.model.diagram.shapes = [];
            const nodeData = this.theDiagram.getNodeDataSource().items();
            //console.log("THENODEDATA:", nodeData);
            nodeData.forEach(node => {
                var nodeToAdd = new domains.IWorkflowShape();
                nodeToAdd.aoId = node.hasOwnProperty('aoId') ? node.aoId : 0;
                nodeToAdd.id = node.id;
                nodeToAdd.type = node.type;
                //nodeToAdd.text = JSON.stringify(node.text);
                nodeToAdd.text = node.text;
                if (this.nodeMap.has(node.id)) {
                    const nodeSupp = this.nodeMap.get(node.id);
                    nodeToAdd.claimAllowedAllTimes = nodeSupp.claimAllowedAllTimes;
                    nodeToAdd.autoComplete = nodeSupp.autoComplete;
                    nodeToAdd.biDictionaryElement = nodeSupp.biDictionaryElement;
                    nodeToAdd.biCompareOperatorPositive = nodeSupp.biCompareOperatorPositive;
                    nodeToAdd.aoAutomatedTask = nodeSupp.aoAutomatedTask;
                    nodeToAdd.stepPermissionedRole = nodeSupp.stepPermissionedRole;
                } else {
                    nodeToAdd.claimAllowedAllTimes = false;
                    nodeToAdd.autoComplete = false;
                    nodeToAdd.biDictionaryElement = undefined;
                    nodeToAdd.biCompareOperatorPositive = undefined;
                    nodeToAdd.aoAutomatedTask = undefined;
                    nodeToAdd.stepPermissionedRole = undefined;
                }
                this.model.diagram.shapes.push(nodeToAdd);
            });

            this.model.diagram.connectors = [];
            const edgeData = this.theDiagram.getEdgeDataSource().items();
            //console.log("THEEDGEDATA:", edgeData);
            edgeData.forEach(edge => {
                var edgeToAdd = new domains.IWorkflowConnector();
                edgeToAdd.aoId = edge.hasOwnProperty('aoId') ? edge.aoId : 0;
                edgeToAdd.id = edge.id;
                edgeToAdd.from = edge.from;
                edgeToAdd.to = edge.to;
                edgeToAdd.text = JSON.stringify(edge.text);
                //try {
                //    const tmp = JSON.parse(edge.text);
                //    edgeToAdd.text = JSON.stringify(edge.text);
                //} catch (e) {
                //    edgeToAdd.text = edge.text;
                //}
                if (this.edgeMap.has(edge.id)) {
                    const edgeSupp = this.edgeMap.get(edge.id);
                    edgeToAdd.positivityIndicator = edgeSupp.positivityIndicator
                } else {
                    edgeToAdd.positivityIndicator = domains.PositivityIndicator.NEUTRAL;
                }
                //console.log("EDGE TO ADD IS:", edgeToAdd);
                this.model.diagram.connectors.push(edgeToAdd);
            });
        };

        loadLovs(): void {
            this.generalService.getLOVs()
                .then(data => {
                    this.biDictionaryElements = (<domains.ILOV[]>data).filter(v => { return v.lovType == domains.LovType.BI_DICTIONARY; });
                    this.biCompareOperators = (<domains.ILOV[]>data).filter(v => { return v.lovType == domains.LovType.COMPARISON_OPERATOR; });
                    this.workflowStepPermissions = (<domains.ILOV[]>data).filter(v => { return v.lovType == domains.LovType.WORKFLOW_STEP_PERMISSION; });
                    this.aoAutomatedTasks = (<domains.ILOV[]>data).filter(v => { return v.lovType == domains.LovType.TASK_AUTOMATION; });
                    if (this.model) {
                        this.selBITriggerElement = this.biDictionaryElements.find(w => w.value == this.model.biDictionaryTriggerElement);
                        this.selBITriggerOperator = this.biCompareOperators.find(w => w.value == this.model.biTriggerOperator);
                    }
                }, (reason) => {
                    toastr.error("Error " + reason);
                });
        };

        $onInit(): void {
            this.loadLovs();
        }

        $onChanges(event): void {
            for (var key in event) {
                if (key === "model") {
                    if (this.model != undefined) {
                        this.initModelComponents();
                    }
                }
            }
        }
    }

    class WorkflowDiagram implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                model: "<",
                onSaveWorkflow: "&"
            };
            this.controller = WorkflowDiagramController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/workflow-diagram.html';
        }
    }
    angular.module(Constants.APP).component("workflowDiagram", new WorkflowDiagram());
}